import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostBinding,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Lot, LotSource, LotTypeEnum } from '../../graphql/service/graphql-auto-main-service';
import { LotAddCarInspectionAdminFormModalComponent } from './components/lot-add-car-inspection-admin-form-modal/lot-add-car-inspection-admin-form-modal.component';
import { AuctionService } from '../../../services/auction.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lot-car-inspection-admin-button',
  templateUrl: './lot-add-car-inspection-admin-button.component.html',
  styleUrls: ['./lot-add-car-inspection-admin-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddCarInspectionAdminButtonComponent implements OnInit, OnDestroy {
  @Input() savedLot: Lot;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Input() fullSize = false;
  @Output() lotShared = new EventEmitter<void>();

  @HostBinding('style.display')
  display: 'none' | 'inline-block' = 'none';

  private inspectionId?: number;

  private subscription = Subscription.EMPTY;

  constructor(
    private readonly translate: TranslateService,
    private readonly modalService: NzModalService,
    private readonly auctionService: AuctionService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscription = this.auctionService
      .getByName(this.savedLot.auctionName)
      .subscribe((auction) => {
        const auctionData = auction?.auctionData;
        this.inspectionId = auctionData?.inspectionId;
        this.display = auctionData?.inspectionEnabled ? 'inline-block' : 'none';
        this.cdr.markForCheck();
      });
  }

  openLotAddCarInspectionAdminFormModal(): void {
    this.modalService.create({
      nzTitle: this.translate.instant('ADD_CAR_INSPECTION.TITLE'),
      nzContent: LotAddCarInspectionAdminFormModalComponent,
      nzWidth: this.fullSize ? '90%' : '40%',
      nzComponentParams: {
        lot: this.savedLot,
        lotType: this.lotType,
        lotSource: this.lotSource,
        lotShared: this.lotShared,
        inspectionId: this.inspectionId,
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
